import { Injectable } from '@angular/core';

export interface Config {
  usuario_id: number;
  url: string;
  token: string;
  nome: string;
  login: string;
  email: string;
  avatar: any;
  tecnico: any;
  s1010: any;
  origem_dado_id: any;
  tipo_assinatura: string;
  cetificado: boolean;
  db_config: {
    origem_dado_id?: number;
    db_servidor: string;
    db_usuario: string;
    db_senha: string;
    db_name: string;
    db_windows_autentication: string;
    db_porta?: number;
    nome: string;
    ambiente_esocial?: number;
  };
  versao: {
    sistema: string;
    bd: string;
  };
}

@Injectable()
export class UtilDadosLogado {
  DadosAcesso(): Config {
    return JSON.parse(localStorage.getItem('DadosAcesso'));
  }
}
